
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"29","height":"29","rx":"4.5","stroke":"#737882"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.226 6.5c-.233 0-.382.177-.382.34v.339h4.296v-.34c0-.162-.15-.339-.383-.339h-3.53zm-1.382.34v.339H8.373c-.738 0-1.383.578-1.383 1.34v2.178h.883V23.21c0 1.013.822 1.76 1.824 1.76H20.29c1.003 0 1.824-.747 1.824-1.76V10.697h.883V8.518c0-.76-.645-1.34-1.383-1.34H18.14V6.84c0-.76-.645-1.339-1.383-1.339h-3.53c-.738 0-1.383.578-1.383 1.34zm-2.971 3.857h12.24V23.21c0 .414-.326.76-.824.76H9.697c-.498 0-.824-.346-.824-.76V10.697zm13.123-1V8.518c0-.162-.15-.34-.383-.34H8.373c-.233 0-.383.178-.383.34v1.18h14.006zm-10.592 3.019v8.814h1v-8.814h-1zm3.088 8.814v-8.814h1v8.814h-1zm3.09-8.814v8.814h1v-8.814h-1z","fill":"#EB5757"}})])
          )
        }
      }
    